import cx from 'classnames';
import React from 'react';

import './modal__img.scss';

interface Props {
    mix?: string;
    children: React.ReactNode | Array<React.ReactNode>;
}

export const ModalImg = ({ children, mix }: Props) => <div className={cx('modal__img', mix)}>{children}</div>;
